<div class="modal-body">
  <!-- Successful payment -->
  <div *ngIf="!isPaymentFailed">
    <lh-payment-receipt [booking]="booking" [paymentMethod]="paymentMethod"></lh-payment-receipt>
  </div>

  <!-- Failed payment -->
  <div *ngIf="isPaymentFailed" class="failed-payment-container">
    <div *ngIf="isLoading" class="text-center">
      <!-- Disabling this text for now as it's misleading when postponing the payment -->
      <!-- {{ 'RETRYING_PAYMENT' | translate }} -->
      <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
    </div>
    <p *ngIf="!isLoading">
      <span>
        {{ 'PAYMENT_FAILED_PART_1' | translate }}
        <strong>{{ booking.price.final.total | price: booking.price.final.currency : 2 : true }}</strong>
        {{ 'PAYMENT_FAILED_PART_2' | translate }}
      </span>
    </p>

    <div [hidden]="!isPaymentOptionsVisible">
      <lh-payment-options
        [(ngModel)]="paymentMethod"
        [booking]="booking"
        [paymentMethods]="paymentMethods"
        [isPaymentDue]="isPaymentDue"
        (paymentMethodSelect)="isPaymentOptionsVisible = false"
        (paymentMethodCancel)="isPaymentOptionsVisible = false"
        #paymentOptions
      >
      </lh-payment-options>
    </div>
  </div>

  <div class="form-group text-center" *ngIf="!isPaymentFailed">
    <button
      id="closePaymentReceipt"
      type="button"
      (click)="done()"
      [disabled]="isLoading"
      class="btn btn-block btn-primary"
    >
      {{ 'DONE' | translate }}
    </button>
  </div>
</div>

<div *ngIf="isPaymentFailed" class="modal-footer no-top-border">
  <div *ngIf="!isPaymentOptionsVisible && paymentOptions && !paymentOptions.isPaymentCardFormVisible">
    <button
      id="retrySamePaymentMethod"
      (click)="retryPayment()"
      [disabled]="isLoading"
      class="btn btn-block"
      [class.btn-default]="!newPaymentCardSelected"
      [class.btn-primary]="newPaymentCardSelected"
    >
      {{ 'RETRY_WITH' | translate }} {{ paymentMethod | paymentMethod: 'summary' }}
    </button>
  </div>

  <div *ngIf="!isPaymentOptionsVisible" class="mt-1">
    <button
      id="useAnotherPaymentMethod"
      (click)="useAnotherPaymentMethod()"
      [disabled]="isLoading"
      class="btn btn-block"
      [class.btn-default]="newPaymentCardSelected"
      [class.btn-primary]="!newPaymentCardSelected"
    >
      {{ 'USE_ANOTHER_PAYMENT_CARD' | translate }}
    </button>

    <div class="text-center mt-1">
      <button
        id="deferPayment"
        (click)="deferPayment()"
        [disabled]="isLoading"
        class="btn btn-block btn-link"
        *ngIf="isDeferPaymentAvailable"
      >
        <!-- TODO: Add tooltip explanations for each option here -->
        <span *ngIf="isPayDirectlyAllowed">{{ 'PAY_IN_SHOP' | translate }}</span>
        <span *ngIf="!isPayDirectlyAllowed">{{ 'PAY_LATER' | translate }}</span>
      </button>
    </div>
  </div>
</div>
